import { useCustomerShowApi } from '@api/customer/show.hook'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware((to) => {
  const customerId = to.params.id

  if (typeof customerId !== 'string' || !customerId) return

  void useCustomerShowApi({ customerId })
})